export default __webpack_public_path__ + "static/team2-c594379b6f917ff3732dd546ddda057a.jpg";